<template>
  <div class="footer-banner">
    <div>
      <img src="../../assets/mobile/icon/5.png" alt="">
      <a href="tel:021-62680166">{{lang === 'zh' ? '电话' : 'Tel'}}：021-62680166</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterBanner",
  computed: {
    lang() {
      return this.$store.state.mlang;
    }
  }
}
</script>

<style lang="less">
@import '../../common/theme';
.mobile-home {
  .footer-banner {
    width: 100%;
    position: fixed;
    bottom: 0;
    opacity: .8;
    background: #037698;
    padding-top: calc(@mobileFont * .3);
    padding-bottom: calc(@mobileFont * .3);
    z-index: 11;
    >div {
      text-align: center;
      img {
        width: calc(@mobileFont * .45);
        margin-right: 8px;
      }
      >* {
        vertical-align: middle;
      }
      a {
        text-decoration: none;
        color: #fff;
      }
    }
  }
}
</style>
